import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { toast } from "sonner";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

// Acceptation obligatoire « 18 ans et plus + CGU + confidentialité » pour les comptes créés avec
// Google / Apple, les comptes existants et toute nouvelle version des CGU.
const OPEN_PATHS = ["/cgu", "/privacy", "/legal", "/reglement-tirage", "/reglement-dojo", "/regles-communaute", "/supprimer-compte"];

export default function TermsGate() {
  const { t } = useTranslation();
  const { user, refreshUser, logout } = useAuth();
  const location = useLocation();
  const [checked, setChecked] = useState(false);
  const [busy, setBusy] = useState(false);

  if (!user || !user.terms_required || OPEN_PATHS.includes(location.pathname)) return null;

  const accept = async () => {
    setBusy(true);
    try {
      await api.post("/auth/accept-terms", { accept: true });
      await refreshUser();
    } catch (err) {
      toast.error(err?.response?.data?.detail || t("account.error"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-end sm:items-center justify-center bg-black/80 p-4" role="dialog"
      aria-modal="true" aria-labelledby="terms-gate-title" data-testid="terms-gate">
      <div className="w-full max-w-md rounded-2xl bg-[#0D1310] border border-white/10 p-5 text-white">
        <h2 id="terms-gate-title" className="text-lg font-bold mb-2">{t("auth.terms_gate_title")}</h2>
        <p className="text-sm text-white/70 mb-4">{t("auth.terms_gate_text")}</p>
        <label className="flex items-start gap-2.5 text-sm text-white/80 mb-4 cursor-pointer">
          <input type="checkbox" checked={checked} onChange={(e) => setChecked(e.target.checked)} className="mt-1"
            data-testid="terms-gate-check" />
          <span>
            {t("auth.terms_prefix")}{" "}
            <a href="/cgu" className="underline">{t("auth.terms_cgu")}</a>{" "}{t("auth.terms_and")}{" "}
            <a href="/privacy" className="underline">{t("auth.terms_privacy")}</a>.
          </span>
        </label>
        <button type="button" disabled={!checked || busy} onClick={accept}
          className="w-full h-11 rounded-xl bg-gold text-black font-bold text-sm disabled:opacity-50" data-testid="terms-gate-accept">
          {t("auth.terms_gate_accept")}
        </button>
        <button type="button" onClick={logout} className="w-full h-10 mt-2 text-sm text-white/50">{t("auth.terms_gate_logout")}</button>
      </div>
    </div>
  );
}
